import { useSelector } from 'react-redux';

export default function useIsAdmin() {
  const { roletitle } = useSelector((state) => state.user.userPermissions);
  return roletitle === 'superadmin';
}
